import { computed, Signal } from '@angular/core';


export function getCommonLabels(isEnglish: Signal<boolean>) {

	const en = isEnglish;

	return {

		/** Common EforAll terms */
		common: {
			Applications: computed(() => en() ? `Applications` : `Aplicaciones`),
			Calendar: computed(() => en() ? `Calendar` : `Calendario`),
			Cohort: computed(() => en() ? `Cohort` : `Grupo`),
			Cohorts: computed(() => en() ? `Cohorts` : `Cohortes`),
			Contact: computed(() => en() ? `Contact` : `Contacto`),
			Contacts: computed(() => en() ? `Contacts` : `Contactos`),
			Demographics: computed(() => en() ? `Demographics` : `Demographics`),
			Entrepreneurs: computed(() => en() ? `Entrepreneurs` : `Emprendedores`),
			EforAll: computed(() => en() ? `EforAll` : `EparaTodos`),
			EforAllWebsite: computed(() => en() ? `eforall.org` : `eparatodos.org`),
			Facilitator: computed(() => en() ? `Facilitator` : `Facilitador`),
			Feedback: computed(() => en() ? `Feedback` : `Comentario`),
			Goals: computed(() => en() ? `Goals` : `Metas`),
			Home: computed(() => en() ? `Home` : `Inicio`),
			Learning: computed(() => en() ? `Learning` : `Aprendizaje`),
			Materials: computed(() => en() ? `Materials` : `Materiales`),
			Mentor: computed(() => en() ? `Mentor` : `Mentor`),
			Mentors: computed(() => en() ? `Mentors` : `Mentores`),
			MyTeam: computed(() => en() ? `My Team` : `Mi equipo`),
			MyCourses: computed(() => en() ? `My Courses` : `Mis cursos`),
			NotAuthorized: computed(() => en() ? `Not Authorized` : `No autorizado`),
			Profile: computed(() => en() ? `Profile` : `Perfil`),
			Programs: computed(() => en() ? `Programs` : `Programas`),
			ProgramManager: computed(() => en() ? `Program Manager` : `Gerente de Programa`),
			SignedAgreements: computed(() => en() ? `Signed Agreements` : `Documentos Firmados`),
			Specialist: computed(() => en() ? `Specialist` : `Especialista`),
			Surveys: computed(() => en() ? `Surveys` : `Encuestas`),
			Topic: computed(() => en() ? `Topic` : `Tema`),
			Topics: computed(() => en() ? `Topics` : `Temas`),
			Venture: computed(() => en() ? `Venture` : `Empresa`),
			Ventures: computed(() => en() ? `Ventures` : `Empresas`),
			Volunteer: computed(() => en() ? `Volunteer` : `Voluntario`),
			About: computed(() => en() ? `About` : `Acerca de`),
			FAQs: computed(() => en() ? `FAQs` : `Preguntas frecuentes`),
			Courses: computed(() => en() ? `Courses` : `Cursos`),
			Advisor: computed(() => en() ? `Advisor` : `Asesor`),
			Agreements: computed(() => en() ? `Agreements` : `Acuerdos`),
			Status: computed(() => en() ? `Status` : `Estatus`),
			English: computed(() => en() ? 'English' : 'Inglés'),
			Spanish: computed(() => en() ? 'Spanish' : 'Español'),
			NoAccess: computed(() => en() ? `No Access` : `Sin Acceso`),
			PreferNotToSay: computed(() => en() ? `Prefer not to say` : `Prefiero no decirlo`),
			BackToApplication: computed(() => en() ? `Back to Application` : `Volver a la aplicación`),
			InvalidCountyFipsId: computed(() => en() ? `Invalid Address field: Please update your address and try again` : `Campo de dirección no válido: actualice su dirección y vuelva a intentarlo`),
			VideoError: computed(() => en()
				? 'There was an error loading this video, please try again later. If this issue persists, please contact [tech@eforall.org](mailto:tech@eforall.org)'
				: 'Se produjo un error al cargar este video. Inténtalo de nuevo más tarde. Si el problema persiste, contacta con [tech@eforall.org](mailto:tech@eforall.org).'
			),
		},
		demographics: {
			optedOutFlyoutHeader: computed(() => en() ? `Demographic Data` : `Datos demográficos`),
			OptedOutMsg1: computed(() => en() ? `Thank you for completing the questionnaire!  We noticed you selected "Prefer not to say" for some of the optional demographic questions.` : `Gracias por completar el cuestionario. Observamos que seleccionaste "Prefiero no decir" para algunas preguntas demográficas opcionales.`),
			OptedOutMsg3: computed(() => en() ? `Please feel free to go back and update your responses, or proceed with your submission as is. We appreciate you considering this.` : `Por favor siéntete libre de regresar y actualizar tus respuestas o continuar con tu envío tal como está. Agradecemos tu consideración.`),
			OptedOutEntMsg2: computed(() => en() ? `As a nonprofit, this information is vital for securing the grant funding that keeps our programs free for everyone. Furthermore, some of our funding partners provide dedicated resources for entrepreneurs from specific backgrounds. To ensure we can consider you for the widest possible range of opportunities and specialized support, we encourage you to provide this information if you are comfortable. All responses are confidential and are only reported in an aggregated, anonymous format.`
				: `Como organización sin fines de lucro, esta información es vital para asegurar las subvenciones que permiten que nuestros programas sean gratuitos para todos. Además, algunos de nuestros socios financiadores proveen recursos específicos para emprendedores con antecedentes y características específicas. Para garantizar que podamos considerarte para la mayor variedad posible de oportunidades y apoyo especializado, te animamos a que nos proporciones esta información si te sientes cómodo. Todas las respuestas son confidenciales y se reportan únicamente de forma agregada y anónima.`),
			OptedOutVolMsg2: computed(() => en() ? `As a nonprofit, this information is vital for securing the grant funding that keeps our programs free for the entrepreneurs we serve.  We encourage you to provide this information if you are comfortable. All responses are confidential and are only reported in an aggregated, anonymous format.`
				: `Como organización sin fines de lucro, esta información es vital para asegurar las subvenciones que permiten que nuestros programas sean gratuitos para los emprendedores a los que ayudamos. Te animamos a proporcionar esta información si te sientes cómodo. Todas las respuestas son confidenciales y se reportan únicamente de forma agregada y anónima. `),
			OptedOutProfileMsg: computed(() => en() ? `We noticed you selected "Prefer not to say" for some of the optional demographic questions.\n\nAs a nonprofit, this information is vital for securing the grant funding that keeps our programs free for everyone. All responses are confidential and are only reported in an aggregated, anonymous format.\n\nPlease feel free to go back and update your responses, or proceed with your submission as is. We appreciate you considering this.` :
				`Observamos que seleccionaste "Prefiero no decir" para algunas de las preguntas demográficas opcionales.\n\nComo organización sin fines de lucro, esta información es vital para asegurar las subvenciones que mantienen nuestros programas gratuitos para todos. Todas las respuestas son confidenciales y se reportan únicamente de forma agregada y anónima.\n\nPor favor no dudes en regresar y actualizar tus respuestas o continuar con su envío tal como está. Agradecemos su consideración.`),
		},


		employmentStatusOptions: {
			Employed: computed(() => en() ? `Employed` : `Empleado`),
			Retired: computed(() => en() ? `Retired` : `Jubilado`),
			Underemployed: computed(() => en() ? `Underemployed` : `Subempleado`),
			Unemployed: computed(() => en() ? `Unemployed` : `Desempleado`),
		},

		/** Standard labels used in forms */
		form: {
			Address: computed(() => en() ? `Address` : `Dirección`),
			Answer: computed(() => en() ? `Answer` : `Respuesta`),
			Birthday: computed(() => en() ? `Birthday` : `Cumpleaños`),
			Details: computed(() => en() ? `Details` : `Detalles`),
			Email: computed(() => en() ? `Email` : `Correo Electrónico`),
			EmploymentStatus: computed(() => en() ? `Employment Status` : `Estado de Empleo`),
			FirstName: computed(() => en() ? `First Name` : `Primer Nombre`),
			Gender: computed(() => en() ? `Gender` : `Género`),
			HeadOfHousehold: computed(() => en() ? `Head of Household (according to IRS)` : `Jefe de hogar (de acuerdo con el IRS)`),
			HispanicOrLatino: computed(() => en() ? `Hispanic Or Latino` : `Hispano o latino`),
			HomeAddress: computed(() => en() ? `Home Address` : `Direccion de Domicilio`),
			PersonAddress: computed(() => en() ? `Address` : `Dirección`),
			HouseholdIncomeLastYear: computed(() => en() ? `Household Income (last year)` : `Ingresos del hogar (año pasado)`),
			Involvement: computed(() => en() ? `Involvement` : `Intervención`),
			LastName: computed(() => en() ? `Last Name` : `Apellido`),
			MiddleInitial: computed(() => en() ? `Middle Initial` : `Inicial del segundo nombre`),
			NativeEnglishSpeaker: computed(() => en() ? `Native English Speaker` : `Hablante nativo de inglés`),
			NativeSpanishSpeaker: computed(() => en() ? `Native Spanish Speaker` : `Hablante nativo de español`),
			OtherGender: computed(() => en() ? `Other Gender` : `Otro género`),
			Phone: computed(() => en() ? `Phone` : `Teléfono`),
			PhoneNumber: computed(() => en() ? `Phone Number` : `Número de teléfono`),
			Progress: computed(() => en() ? `Progress` : `Progreso`),
			Question: computed(() => en() ? `Question` : `Pregunta`),
			Race: computed(() => en() ? `Race` : `Raza`),
			SelectEllipses: computed(() => en() ? `Select...` : `Seleccionar...`),
			Summary: computed(() => en() ? `Summary` : `Resumen`),
			Title: computed(() => en() ? `Title` : `Título`),
			Veteran: computed(() => en() ? `Veteran` : `Veterano`),
			YourTitle: computed(() => en() ? `Your Title` : `Tu título`),
			WillingToVolunteerIn: computed(() => en() ? `Willing to Volunteer in` : `Dispuesto a ser voluntario en`),
			InterestedIn: computed(() => en() ? `Interested in` : `Interesado en`),
			RequestCategory: computed(() => en() ? `Request Category` : `Categorías para solicitar apoyo`),
			AvailableMonth: computed(() => en() ? `Available Month` : `Mes disponible`),
			Expertise: computed(() => en() ? `Expertise` : `Experticia`),
			Entrepreneur: computed(() => en() ? `Entrepreneur` : `Emprendedor`),
			LinkedInURL: computed(() => en() ? `LinkedIn in URL` : `‘Enlace de LinkedIn`),
			ENFluent: computed(() => en() ? `Is fluent in english` : `Es fluida en ingles`),
			ESFluent: computed(() => en() ? `Is fluent in spanish` : `Es fluida en español`),
			MentorInterest: computed(() => en() ? `Is mentor interest` : `Es el interés del mentor`),
			SubjectMatterExpertInterest: computed(() => en() ? `Is subject matter expert interest` : `Es el interés de los expertos en la materia`),
			Language: computed(() => en() ? `Language` : `Idioma`),
			TypeOfBusiness: computed(() => en() ? `Type of business` : `Tipo de negocio`),
			Industry: computed(() => en() ? `Industry` : `Industria`),
			Offerings: computed(() => en() ? `Offerings` : `Ofrecimientos`),
			AnnualRevenue: computed(() => en() ? `Annual Revenue` : `Ingresos anuales`),
			InvolvementStatus: computed(() => en() ? `Involvement Status` : `Estado de participación`),
			HouseholdSize: computed(() => en() ? `Household Size` : `Cantidad de miembros del hogar`),
			BusinessName: computed(() => en() ? `Business Name` : `Nombre del negocio`),
			StageOfBusiness: computed(() => en() ? `Stage of business` : `Etapa de negocios`),
			IdeaName: computed(() => en() ? `Idea Name` : `Nombre de la idea`),
			Website: computed(() => en() ? `Website` : `Sitio web`),
		},

		genderOption: {
			Female: computed(() => en() ? `Female` : `Femenino`),
			Male: computed(() => en() ? `Male` : `Masculino`),
			NonBinary: computed(() => en() ? `Non-Binary` : `No binario`),
			Other: computed(() => en() ? `Other` : `Otro`),
		},


		headOfHouseholdOptions: {
			IAmHead: computed(() => en() ? `I am Head of Household` : `Soy jefe de hogar`),
			IAmNotHead: computed(() => en() ? `I am NOT Head of Household` : `NO soy jefe de hogar`),
		},

		hispanicOptions: {
			IAmHispanic: computed(() => en() ? `I am Hispanic or Latino` : `Soy hispano o latino`),
			IAmNotHispanic: computed(() => en() ? `I am NOT Hispanic or Latino` : `NO soy hispano o latino`),
		},


		nativeEnglishOptions: {
			NativeSpeaker: computed(() => en() ? `I am a Native English Speaker` : `Soy un hablante nativo de inglés`),
			NotNativeSpeaker: computed(() => en() ? `I am NOT a Native English Speaker` : `NO soy un hablante nativo de inglés`),
		},


		nativeSpanishOptions: {
			NativeSpeaker: computed(() => en() ? `I am a Native Spanish Speaker` : `Soy un hablante nativo de español`),
			NotNativeSpeaker: computed(() => en() ? `I am NOT a Native Spanish Speaker` : `NO soy un hablante nativo de español`),
		},


		raceOptions: {
			AfricanAmerican: computed(() => en() ? 'Black or African American' : 'Negro o afroamericano'),
			AmericanIndian: computed(() => en() ? 'American Indian or Alaska Native' : 'Indio americano o nativo de Alaska'),
			Asian: computed(() => en() ? 'Asian' : 'Asiático'),
			PacificIslander: computed(() => en() ? 'Native Hawaiian or Other Pacific Islander' : 'Nativo hawaiano u otro isleño del Pacífico'),
			White: computed(() => en() ? 'White' : 'Blanco'),
		},


		veteranOptions: {
			IAmVeteran: computed(() => en() ? `I am a U.S. Veteran` : `Soy EEUU Veterano`),
			IAmNotVeteran: computed(() => en() ? `I am NOT a U.S. Veteran` : `No soy EEUU Veterano`),
		},



		/** Standard labels used on buttons */
		button: {
			Apply: computed(() => en() ? 'Apply' : 'Aplica'),
			ApplyInLanguage: computed(() => en() ? 'Solicite en español' : 'Apply in English'),
			Cancel: computed(() => en() ? 'Cancel' : `Cancelar`),
			Continue: computed(() => en() ? 'Continue' : `Seguir`),
			Close: computed(() => en() ? 'Close' : `Cerrar`),
			LearnMore: computed(() => en() ? 'Learn More' : 'Conoce más'),
			Next: computed(() => en() ? `Next` : `Próximo`),
			No: computed(() => en() ? `No` : `No`),
			Okay: computed(() => en() ? `Okay` : `Bueno`),
			Open: computed(() => en() ? `Open` : `Abrir`),
			Previous: computed(() => en() ? `Previous` : `Anterior`),
			Remove: computed(() => en() ? `Remove` : `Eliminar`),
			Save: computed(() => en() ? `Save` : `Guardar`),
			SignOut: computed(() => en() ? `Sign Out` : `Desconectar`),
			Submit: computed(() => en() ? `Submit` : `Enviar`),
			View: computed(() => en() ? `View` : `Ver`),
			Yes: computed(() => en() ? `Yes` : `Sí`),
			Edit: computed(() => en() ? `Edit` : `Editar`),
			ReRecord: computed(() => en() ? `Re-Record` : `Vuelva a grabar`),
			GoBack: computed(() => en() ? `Go back` : `Volver`),
			Proceed: computed(() => en() ? `Proceed` : `Proceder`),
		},


		status: {
			Open: computed(() => en() ? 'Open' : `Abierto`),
			Complete: computed(() => en() ? 'Complete' : `Completa`),
			Missed: computed(() => en() ? 'Missed' : `Sin Completar`),
			NotOpenYet: computed(() => en() ? 'Not Open Yet' : `Aun no Abierta`),
			Unavailable: computed(() => en() ? 'Unavailable' : `No disponible`),
			Closed: computed(() => en() ? 'Closed' : `Cerrado`),
			Pending: computed(() => en() ? 'Pending' : `Pendiente`),
			Scheduled: computed(() => en() ? 'Scheduled' : `Programado`),
			Waitlist: computed(() => en() ? 'Waitlist' : `Lista de espera`),
			Assigned: computed(() => en() ? 'Assigned' : `Asignado`),
		},

		topicLongName: <{ [index: string]: Signal<string> }>{
			'Accelerator Kick Off': computed(() => en() ? 'Accelerator Kick Off' : 'Lanzamiento del Acelerador'),
			'Business Models and Customer Segments': computed(() => en() ? 'Business Models and Customer Segments' : 'Modelos de negocio y Segmentos de clientes'),
			'Connecting Customers to Value': computed(() => en() ? 'Connecting Customers to Value' : 'Conectando las necesidades del cliente con mi producto'),
			'Prioritizing Customers Testing Assumptions': computed(() => en() ? 'Prioritizing Customers and Testing Assumptions' : 'Priorización de clientes y validacion de supuestos'),
			'Testing Assumptions Through Surveys': computed(() => en() ? 'Testing Assumptions Through Surveys' : 'Prueba de supuestos a través de encuestas '),
			'Setting Goals and Working through Surveys': computed(() => en() ? 'Setting Goals and Working through Surveys' : 'Establecimiento de metas y elaboración de encuestas'),
			'Testing Profitability Quick Calculations': computed(() => en() ? 'Testing Profitability through Quick Calculations' : 'Cálculos rápidos para determinar ganancias'),
			'Checking In and Planning Ahead': computed(() => en() ? 'Checking In and Planning Ahead' : 'Revision del programa hasta ahora y planificación de los proximos meses'),
			'Exploring Pricing Strategies': computed(() => en() ? 'Exploring Pricing Strategies' : 'Exploración de estrategias de precios'),
			'Entrepreneur Tell All/Open Class': computed(() => en() ? 'Entrepreneur Tell All/Open Class' : 'Clase abierta- Sugerencias: Emprendedor Invitado o Herramientas en Línea/Google Suite, etc.'),
			'Progress Pitch': computed(() => en() ? 'Progress Pitch' : 'Presentación del progreso'),
			'Branding and Messaging': computed(() => en() ? 'Branding and Messaging' : 'Creación de la marca (Branding) y el mensaje'),
			'Forecasting Revenues and Costs': computed(() => en() ? 'Forecasting Revenues and Costs' : 'Prevision de costos e ingresos'),
			'Legal Issues of Business': computed(() => en() ? 'Legal Issues of Business' : 'Aspectos legales'),
			'Accounting': computed(() => en() ? 'Accounting' : 'Contabilidad'),
			'Insurance': computed(() => en() ? 'Insurance' : 'Seguros'),
			'Reaching Customers through Websites': computed(() => en() ? 'Reaching Customers through Websites' : 'Llegar a los clientes a través de paginas web'),
			'Marketing and Social Media': computed(() => en() ? 'Marketing and Social Media' : 'Comercialización (Marketing) y redes sociales'),
			'Asking for Money': computed(() => en() ? 'Asking for Money' : 'Acceso a capital'),
			'Presentation Skills': computed(() => en() ? 'Presentation Skills' : 'Aptitudes de presentación (hablar en público)'),
			'Marketing through Media Outlets': computed(() => en() ? 'Marketing through Media Outlets' : 'Marketing a través de los medios'),
			'Purpose and Impact of Your Business': computed(() => en() ? 'Exploring the Purpose and Impact of Your Business' : 'Explorando el propósito y el impacto de su negocio'),
			'Selling to your Customer': computed(() => en() ? 'Selling to your Customer' : 'Vender a su cliente'),
			'Practice Presentations': computed(() => en() ? 'Practice Presentations' : 'Práctica para la Presentación Final'),
			'Final Presentation Practice': computed(() => en() ? 'Final Presentation Practice' : 'Práctica para la Presentación Final'),
			'Building Successful Business Models and Plans': computed(() => en() ? 'Building Successful Business Models and Plans' : 'Creación de modelos y planes de negocio'),
			'Segmentation and Value Strategies': computed(() => en() ? 'Segmentation and Value Strategies' : 'Perspectivas del cliente: segmentación y estrategias de valor'),
			'Assumption Testing in Entrepreneurship': computed(() => en() ? 'Assumption Testing in Entrepreneurship' : 'Prueba de Supuestos en el Emprendimiento'),
			'Survey Analysis and Strategic Goal Setting': computed(() => en() ? 'Survey Analysis and Strategic Goal Setting' : 'Análisis de Encuestas y Definición Estratégica de Metas'),
			'Foundations of Entrepreneurial Finance': computed(() => en() ? 'Foundations of Entrepreneurial Finance' : 'Fundamentos de Finanzas Empresariales'),
			'Revenue Strategies and Financial Projections': computed(() => en() ? 'Revenue Strategies and Financial Projections' : 'Estrategias de Ingresos y Proyecciones Financieras'),
			'Entrepreneurial Finance & Funding Strategies': computed(() => en() ? 'Entrepreneurial Finance & Funding Strategies' : 'Finanzas Emprendedoras y Estrategias de Financiamiento'),
			'Profitability and Risk Management': computed(() => en() ? 'Profitability and Risk Management' : 'Rentabilidad y Gestión de Riesgos'),
			'Make Your Message Matter': computed(() => en() ? 'Make Your Message Matter' : 'Haz que tu Mensaje Importe'),
			'Marketing in Action': computed(() => en() ? 'Marketing in Action' : 'Marketing en Acción'),
		},

		eventTypeFullName: <{ [index: string]: Signal<string> }>{
			'Accelerator Session': computed(() => en() ? 'Accelerator Session' : 'Sesión del acelerador'),
		},

		volunteerApplication: {
			willingToVolunteerInOptions: {
				English: computed(() => en() ? 'English' : 'Inglés'),
				hasNotEnVideo: computed(() => en() ? 'You can not sign up in English because you do not have an intro video in this language' : 'No puedes registrarte en inglés porque no tienes un video de introducción en este idioma'),
				Spanish: computed(() => en() ? 'Spanish' : 'Español'),
				hasNotEsVideo: computed(() => en() ? 'You can not sign up in Spanish because you do not have an intro video in this language' : 'No puedes registrarte en español porque no tienes un video de introducción en este idioma'),
			},

			interestedInOptions: {
				MentorHeader: computed(() => en() ? 'Mentor' : 'Mentor'),
				MentorDesc: computed(() => en() ? 'Meet with a team of entrepreneurs for two hours every other week for ten weeks.' : 'Reúnase con un equipo de empresarios durante dos horas cada dos semanas durante diez semanas.'),
				InClassSpecialist: computed(() => en() ? 'In-Class Topic Specialist' : 'Especialista para las clases'),
				InClassSpecialistDesc: computed(() => en() ? 'A two hour commitment to facilitate a topic for an entire cohort during class.' : 'Un compromiso de dos horas para facilitar un tema para una cohorte completa durante la clase.'),
				OfficeHoursSpecialist: computed(() => en() ? 'Office Hours Topic Specialist' : 'Especialista disponible en horas de oficina'),
				OfficeHoursSpecialistDesc: computed(() => en() ? 'A minimum of one hour commitment to support entrepreneurs individually or in small groups outside of classes on a specific topic of the curriculum.' : 'Un compromiso mínimo de una hora para apoyar a los emprendedores individualmente o en pequeños grupos fuera de las clases sobre un tema específico del plan de estudios.'),
			},

			expertiseOptions: {
				Business: computed(() => en() ? 'Business' : 'Empresa'),
				Management: computed(() => en() ? 'Management' : 'Gestión'),
				Marketing: computed(() => en() ? 'Marketing' : 'Márketing'),
				PresentationSkills: computed(() => en() ? 'Presentation Skills' : 'Aptitudes de presentación (hablar en público)'),
				Finance: computed(() => en() ? 'Finance' : 'Finanzas'),
				Insurance: computed(() => en() ? 'Insurance' : 'Seguros'),
				Legal: computed(() => en() ? 'Legal' : 'Aspectos legales'),
				NonProfit: computed(() => en() ? 'Non-Profit' : 'No lucrativo'),
				Sales: computed(() => en() ? 'Sales' : 'Vender'),
				Technology: computed(() => en() ? 'Technology' : 'Tecnología'),
			},

			entrepreneurOptions: {
				StartedBusiness: computed(() => en() ? 'I have started a business' : 'He comenzado un negocio'),
				NotStartedBusiness: computed(() => en() ? 'I have not started a business' : 'No he comenzado un negocio'),
			},
		},

		months: <{ [index: string]: Signal<string | undefined> }>{
			January: computed(() => en() ? 'January' : 'Enero'),
			February: computed(() => en() ? 'February' : 'Febrero'),
			March: computed(() => en() ? 'March' : 'Marzo'),
			April: computed(() => en() ? 'April' : 'Abril'),
			May: computed(() => en() ? 'May' : 'Mayo'),
			June: computed(() => en() ? 'June' : 'Junio'),
			July: computed(() => en() ? 'July' : 'Julio'),
			August: computed(() => en() ? 'August' : 'Agosto'),
			September: computed(() => en() ? 'September' : 'Septiembre'),
			October: computed(() => en() ? 'October' : 'Octubre'),
			November: computed(() => en() ? 'November' : 'Noviembre'),
			December: computed(() => en() ? 'December' : 'Diciembre'),
			enero: computed(() => en() ? 'January' : 'Enero'),
			febrero: computed(() => en() ? 'February' : 'Febrero'),
			marzo: computed(() => en() ? 'March' : 'Marzo'),
			abril: computed(() => en() ? 'April' : 'Abril'),
			mayo: computed(() => en() ? 'May' : 'Mayo'),
			junio: computed(() => en() ? 'June' : 'Junio'),
			julio: computed(() => en() ? 'July' : 'Julio'),
			agosto: computed(() => en() ? 'August' : 'Agosto'),
			septiembre: computed(() => en() ? 'September' : 'Septiembre'),
			octubre: computed(() => en() ? 'October' : 'Octubre'),
			noviembre: computed(() => en() ? 'November' : 'Noviembre'),
			diciembre: computed(() => en() ? 'December' : 'Diciembre'),
		},

		GoHome: computed(() => en() ? `Go Home` : `Ir a inicio`),
		home: {
			Advisor: computed(() => en() ? `Advisor` : `Asesor`),
			AskAdvisor: computed(() => en() ? `Ask the Advisor` : `Pregunta a la Asesora`),
			AskAdvisorDesc: computed(() => en() ? `Use this great tool to find helpful information for your business. Type your business related questions and discover how the Advisor can be a valuable resource in your entrepreneurial journey!` : `Usa esta excelente herramienta para encontrar información útil para tu negocio. ¡Escribe tus preguntas sobre negocios y descubre cómo el asesor puede ser un valioso recurso en tu camino empresarial!`),
			VisitOurWebsite: computed(() => en() ? `Visit Our Website` : `Visite nuestro sitio web`),
			WebsiteLink: computed(() => en() ? `https://eforall.org/` : `https://eforall.org/es/`),
			LearnAbtAccelerator: computed(() => en() ? `Learn about our Accelerator program` : `Aprenda sobre nuestro programa de aceleradores`),
			AcceleratorLink: computed(() => en() ? `https://eforall.org/business-accelerator-program/` : `https://eforall.org/es/acelerador-de-negocios/`),
			LearnAbtVolunteering: computed(() => en() ? `Learn about Volunteering` : `Aprenda sobre el voluntariado`),
			VolunteeringLink: computed(() => en() ? `https://eforall.org/volunteering/` : `https://eforall.org/es/voluntariado/`),
		},
		businessStageOptions: {
			Stage0: computed(() => en() ? `I have an idea for a business` : `Tengo una idea de negocios`),
			Stage1: computed(() => en() ? `My business has started with a little sales` : `Mi negocio ha comenzado con pocas ventas`),
			Stage2: computed(() => en() ? `My business is stable and I pay myself` : `Mi negocio es estable y me pago un salario`),
		},
		businessTypeOptions: {
			Profit: computed(() => en() ? `For Profit` : `Con fines de lucro`),
			NonProfit: computed(() => en() ? `Non-Profit` : `Sin fines de lucro`),
		},
		businessOfferingsOptions: {
			Products: computed(() => en() ? `Products` : `Productos`),
			Services: computed(() => en() ? `Services` : `Servicios`),
			Both: computed(() => en() ? `Products and Services` : `Productos y servicios`),
		},
		involvementStatusOptions: {
			FullTime: computed(() => en() ? `I work on this full-time` : `Trabajo en este tiempo completo`),
			PartTime: computed(() => en() ? `I work on this part-time` : `Trabajo en este tiempo parcial`),
		},
		language: {
			English: computed(() => en() ? `English` : `Inglés`),
			Spanish: computed(() => en() ? `Spanish` : `Español`),
		},

		TimeZoneMap: {
			long: {
				1: computed(() => en() ? `Eastern Time` : `Hora del Este`),
				3: computed(() => en() ? `Pacific Time` : `Hora del Pacífico`),
				5: computed(() => en() ? `Central Time` : `Hora Central`),
				7: computed(() => en() ? `Mountain Time` : `Hora de Montaña`),
			},
			short: {
				1: computed(() => en() ? `ET` : `ET`),
				3: computed(() => en() ? `PT` : `PT`),
				5: computed(() => en() ? `CT` : `CT`),
				7: computed(() => en() ? `MT` : `MT`),
			}
		},

		DayNamesMap: {
			long: {
				0: computed(() => en() ? `Monday` : `Lunes`),
				1: computed(() => en() ? `Tuesday` : `Martes`),
				2: computed(() => en() ? `Wednesday` : `Miércoles`),
				3: computed(() => en() ? `Thursday` : `Jueves`),
				4: computed(() => en() ? `Friday` : `Viernes`),
				5: computed(() => en() ? `Saturday` : `Sábado`),
				6: computed(() => en() ? `Sunday` : `Domingo`),
			},
			short: {
				0: computed(() => en() ? `Mon` : `Lun`),
				1: computed(() => en() ? `Tue` : `Mar`),
				2: computed(() => en() ? `Wed` : `Mier`),
				3: computed(() => en() ? `Thu` : `Jue`),
				4: computed(() => en() ? `Fri` : `Vie`),
				5: computed(() => en() ? `Sat` : `Sab`),
				6: computed(() => en() ? `Sun` : `Dom`),
			}
		},
	};
}
